import { FC, memo } from 'react'

import { FormInputProps } from 'brief-form'
import { Request } from 'commons/utils/request'
import { ColumnMultiSelect } from 'ui/components/Select'

type Props = FormInputProps<
  string[],
  {
    selectedSubsidiaries?: { value: number; label: string }[]
  }
>

type SearchItem = {
  companyName: string
  customerStatus: string
  id: 0
}

export const CompaniesBeingHeld: FC<Props> = memo((props) => {
  const { value, onChange, selectedSubsidiaries } = props

  return (
    <ColumnMultiSelect
      value={value || []}
      data-qa="Add Company selector"
      onChange={onChange}
      searchable
      data={selectedSubsidiaries}
      serverOptions={{
        url: Request.urls.bank.companySearch,
        limit: 500,
        requestSearchString: 'searchString',
        mapper: (item: SearchItem) => ({
          label: item.companyName,
          value: item.id
        })
      }}
    />
  )
})
